import { taxpayerCategoryApi } from "../api";

const TaxpayerCategoryService = {
  fetchDropdown: async () => {
    const response = await taxpayerCategoryApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default TaxpayerCategoryService;
